/** Версии JSON-сцены доски. */
export const SCENE_VERSION_V1 = 1;
export const SCENE_VERSION_V2 = 2;
/** Текущая версия при записи snapshot (ADR 004). */
export const SCENE_VERSION = SCENE_VERSION_V2;
